import {StringRule} from '../rules';

const emailPreset = new StringRule('Неправильная почта')
    .testRegexp(/([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})/)
    .final();

export {emailPreset};
